import React from "react";
import { CheckCircle2 } from "lucide-react";
import { useIgualdad } from "./igualdad-store.jsx";

/* El shell del modulo ya no gestiona sesion ni chrome: la sesion es global
   (Gate en App.jsx) y el topbar es unico (src/topbar.jsx). Solo queda el
   toast del modulo. */
function IgualdadShell({ children }) {
  const { toast } = useIgualdad();

  return (
    <>
      {children}
      {toast ? (
        <div className="rb-toast"><CheckCircle2 size={16} /> {toast}</div>
      ) : null}
    </>
  );
}

export { IgualdadShell };
